import { createStore } from 'vuex';
import common from '@/store/common';
import consumer from '@/store/consumer';

export default createStore({
  modules: {
    common,
    consumer,
  },
});
